import React from 'react';
import './todoCounter.css';
import { TodoContext } from './TodoContext';

function TodoCounter(){
    const {
        completeTodos,
        totalTodos
    } = React.useContext(TodoContext);

    return(
        <h2 className="counter">
            Has completado {completeTodos} de {totalTodos}
        </h2>
    );
}

export{TodoCounter};